<clr-modal
  [clrModalOpen]="isModalOpen()"
  (clrModalOpenChange)="isModalOpen.set($event)"
  [clrModalClosable]="true"
  [clrModalSize]="'xl'">
  <h3 class="modal-title">
    {{ 'Tabelle verwalten' | mrTranslate }}
    @if (route().title; as title) {
      : {{ title }}
    }
  </h3>
  <div class="modal-body d-f col gap-5" style="height: 70vh">
    <div class="d-f col width100 clr-flex-md-row clr-align-items-stretch clr-align-items-md-center gap-10 w-100-p">
      <div class="btn-group btn-icon">
        <button class="btn" (click)="selectedRow.set(null); form.reset()">
          <clr-tooltip>
            <cds-icon clrTooltipTrigger shape="file" />
            <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
              {{ 'Neuen Eintrag hinzufügen' | mrTranslate }}
            </clr-tooltip-content>
          </clr-tooltip>
        </button>
        @if (!isRep) {
          <button class="btn btn-danger" [disabled]="!selectedRow()" (click)="deleteRow()">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="times" />
              <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                {{ 'den Eintrag löschen' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>
        }
      </div>

      <form clrForm class="nm flex-1-10-auto width100" (ngSubmit)="onSubmit()">
        <clr-input-container class="nm">
          <label class="clr-required-mark">{{ 'Bezeichnung' | mrTranslate }}</label>
          <input clrInput type="text" [formControl]="form.controls.Bezeichnung" />
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
        </clr-input-container>
      </form>
      <div class="btn-group btn-success nxm">
        <button (click)="onSubmit()" class="btn btn-sm" [clrLoading]="loadState()">
          {{ (selectedRow() ? 'Speichern' : 'Erstellen') | mrTranslate }}
        </button>
      </div>
    </div>

    <div class="flex-1-1-0 d-f row gap-25 w-100-p" style="min-height: 120px">
      @if (isLoading()) {
        <clr-spinner class="centred" />
      } @else if (table().columns.length) {
        <clr-datagrid
          class="datagrid-compact fill-space"
          [deselectButton]="true"
          [clrDgRowSelection]="true"
          [clrDgItemsIdentityFn]="row => row?.ID"
          [clrDgSelectionType]="'single'"
          [clrDgSelected]="[selectedRow()]"
          (clrDgSelectedChange)="selectedRow.set($event[0])">
          @for (column of table().columns; track column.id) {
            <clr-dg-column [clrDgField]="column.id">
              <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['anweisung'] }">
                {{ column.id | titlecase | mrTranslate }}
              </ng-container>
            </clr-dg-column>
          }
          <clr-dg-row *clrDgItems="let row of table().rows" [clrDgItem]="row">
            @for (cell of table().columns; track cell.id) {
              <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
            }
          </clr-dg-row>
          <clr-dg-footer>{{ table().rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
        </clr-datagrid>
      }
      <form
        clrForm
        autocomplete="off"
        [formGroup]="form"
        (ngSubmit)="onSubmit()"
        class="width100 d-f col gap-10"
        [clrLabelSize]="5"
        style="min-width: 300px">
        <clr-checkbox-container>
          <clr-checkbox-wrapper>
            <label>{{ 'Prüfen' | mrTranslate }}</label>
            <input type="checkbox" clrToggle formControlName="Prüfung" />
          </clr-checkbox-wrapper>
        </clr-checkbox-container>
        <app-preview-thumbnails
          #anweisung
          [showLabel]="true"
          [title]="'Anweisung' | mrTranslate"
          [drag_drop]="true"
          [maxAmount]="1"
          [maxSize]="2"
          [acceptTypes]="'.pdf'"
          [skipSavedOnPack]="false"
          (openPdfOverlay)="showPDF($event)"
          [showCamera]="false" />
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn" (click)="close()">
      {{ 'Schliessen' | mrTranslate }}
    </button>
  </div>
</clr-modal>
